module.exports = __webpack_public_path__ + "img/poster-2.3486837b.jpg";